var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChangepassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 10C1.66699 6.85754 1.66699 5.28587 2.64366 4.31004C3.62033 3.33421 5.19116 3.33337 8.33366 3.33337H11.667C14.8095 3.33337 16.3812 3.33337 17.357 4.31004C18.3328 5.28671 18.3337 6.85754 18.3337 10C18.3337 13.1425 18.3337 14.7142 17.357 15.69C16.3803 16.6659 14.8095 16.6667 11.667 16.6667H8.33366C5.19116 16.6667 3.61949 16.6667 2.64366 15.69C1.66783 14.7134 1.66699 13.1425 1.66699 10Z",
    stroke: "#363333",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 8.33337V11.6667M8.55699 9.16671L11.4437 10.8334M11.4437 9.16671L8.55699 10.8334M5.61116 8.33337V11.6667M4.16699 9.16671L7.05366 10.8334M7.05366 9.16671L4.16699 10.8334M14.3903 8.33337V11.6667M12.947 9.16671L15.8337 10.8334M15.8337 9.16671L12.9462 10.8334",
    stroke: "#363333",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangepassword);
export default __webpack_public_path__ + "static/media/changepassword.04e446f0f690f65044350745a3f20ff2.svg";
export { ForwardRef as ReactComponent };